module.exports = __webpack_public_path__ + "static/media/IMG_20191204_134127.8c013d38.jpg";